// extracted by mini-css-extract-plugin
export var cardContainer = "_mq-0";
export var cardHeader = "_mq-2";
export var collapsedState = "_mq-3";
export var dragHandle = "_mq-5";
export var dragHandleIcon = "_mq-6";
export var dragging = "_mq-1";
export var titleArea = "_mq-4";